import { useEffect, useSyncExternalStore } from "react";
import {
  isHeroOutageActive,
  subscribeHeroOutage,
} from "@/features/heroOutage/heroOutageStore";
import { useCurrentUser, userIsRealAppAdmin } from "@/lib/auth";

/**
 * Hinweis bei manuell gekappter Hero-Verbindung oder wenn Hero-Calls fehlschlagen.
 * Den orangen Kill-Switch-Text sehen nur App-Admins; alle anderen den Störungsbanner.
 */
export function HeroOutageBanner() {
  const { user, reload } = useCurrentUser();
  const outage = useSyncExternalStore(
    subscribeHeroOutage,
    isHeroOutageActive,
    () => false,
  );
  const killSwitch = user?.hero_outbound_disabled === true;
  const showAdminKillSwitch = killSwitch && userIsRealAppAdmin(user);

  useEffect(() => {
    const onChange = () => {
      reload();
    };
    window.addEventListener("eh-hero-outbound-changed", onChange);
    return () => window.removeEventListener("eh-hero-outbound-changed", onChange);
  }, [reload]);

  if (!killSwitch && !outage) return null;

  if (showAdminKillSwitch) {
    return (
      <div
        role="status"
        className="border-b border-orange-900/50 bg-orange-700 px-4 py-1.5 text-center text-xs font-semibold tracking-wide text-white"
      >
        Hero-Verbindung ist manuell gekappt – Sync und Live-Calls zu Hero sind
        gestoppt.
      </div>
    );
  }

  return (
    <div
      role="status"
      className="border-b border-amber-800/40 bg-amber-600 px-4 py-1.5 text-center text-xs font-semibold tracking-wide text-white"
    >
      Hero ist derzeit nicht erreichbar – abhängige Funktionen können
      eingeschränkt sein oder fehlen.
    </div>
  );
}
